function modifyDate (date) { 
    let day = '';
    let month = '';
    let year = date.slice(0, 4);

    const months = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];

    if (date[5] === '0') {
        month = months[parseInt(date.slice(6,7)) - 1];
    } else {
        month = months[parseInt(date.slice(5,7)) -1];
    }

    if (date[8] === '0') {
        day = date.slice(9,10)
    } else {
        day = date.slice(8,10)
    }

    let full_date = `${day} ${month} ${year}`
    return full_date;
}

function timestampToDate(timestamp) {
    let date = new Date(timestamp*1000).toLocaleDateString().split('.');
    let months= ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
    let day = date[0];
    let month = months[parseInt(date[1])-1]
    let year = date[2]
    return `${day} ${month} ${year}`
}   

// date from Wed Mar 03 2032 14:12:01 GMT+0100 (czas środkowoeuropejski standardowy) to 03.03.2032
function convertDate(date) {
    return date.toISOString().slice(0,10).split('-').reverse().join('.')
}

function convertUTCDate(date) {
    let dateString = date.toLocaleString();
    if (dateString[1] === '.') {
        return date.toLocaleString().slice(0, 9);
    }
    return date.toLocaleString().slice(0, 10);
}

// date from LocalTimeString to hh:mm
function convertTime(date) {
    return date.toLocaleTimeString().slice(0,5)
}

// accepted format dd.mm.yyyy, d.mm.yyyy, dd/mm/yyyy, or d/mm/yyyy
function datePhrase(date) {
    if (date[1] === '.' || date[1] === '/') { // d.mm.yyyy, d/mm/yyyy
        date = '0' + date;
    }
    let months= ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
    let day = '';
    if(date[0] === '0') {
        day += date.slice(1, 2);
    } else {
        day += date.slice(0, 2);
    }
    let month = '';
    if (date[3] === '0') {
        month = months[date.slice(4, 5)-1]
    } else {
        month = months[date.slice(3, 5)-1]
    }
    let year = date.slice(6, 10)
    return `${day} ${month} ${year}`
}

function countDays(date) {
    date = date*1000
    let date1 = new Date(date);
    let date2 = new Date();
    let difference = date2.getTime() - date1.getTime()
    let days = Math.ceil(difference / (1000*3600*24))
    return days;
}

function getWeekday (number) {
    let weekdays = ['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela']
    return weekdays[number-1]
}

function convertPrice (price, noDecimal=false) {
    let rounded_price
    if (noDecimal) {
        rounded_price = parseFloat(price).toFixed(0)
    } else {
        rounded_price = parseFloat(price).toFixed(2)
    }
    const price_str = rounded_price.toString()
    return price_str.replace('.', ',')
}

function convertColors (color) {
    let result_color = '';
    switch(color) {
        case 'green':
            result_color = '#2b9044';
            break;
        case 'blue':
            result_color = '#0d60a6';
            break;
        case 'red':
            result_color = '#872c66';
            break;
        case 'brown':
            result_color = '#5b5959';
            break;
        case 'cyan':
            result_color = '#017c93';
            break;
        case 'magnet':
            result_color = '#bb60d5';
            break;
        case 'orange':
            result_color = '#c77405';
            break;
        case 'dgreen':
            result_color = '#374e0c';
            break;
        case 'indigo':
            result_color = '#5b009d';
            break;
        case 'black':
            result_color = '#333';
            break;
        case 'azur':
            result_color = '#336699';
            break;
        default: 
            result_color = 'black';
    }

    return result_color;
}

    export {
        modifyDate,
        timestampToDate,
        datePhrase,
        getWeekday,
        countDays,
        convertPrice,
        convertDate,
        convertUTCDate,
        convertTime,
        convertColors
    }